import { loadItemReadingPaneForDeeplink } from '../actions/loadItemReadingPaneForDeeplink';
import { IMID_QUERY_PARAM, ITEMID_QUERY_PARAM } from '../utils/constants';
import { observer } from 'mobx-react-lite';
import { isFeatureEnabled } from 'owa-feature-flags';
import { ImmersiveReaderContainer } from 'owa-immersive-reader';
import loc from 'owa-localize';
import { loading } from 'owa-locstrings/lib/strings/loading.locstring.json';
import { composeStore } from 'owa-mail-compose-store';
import { ComposeCommandingBar } from 'owa-mail-compose-view';
import { DeeplinkMailItemCommandingBar } from 'owa-mail-deeplink-rp-commandbar';
import ReadingPaneContainer from 'owa-mail-reading-pane-container/lib/components/ReadingPaneContainer';
import { getItemReadingPaneViewState, ItemReadingPaneViewState } from 'owa-mail-reading-pane-store';
import getItemIdFromInternetMessageId from 'owa-mail-reading-pane-store/lib/utils/getItemIdFromInternetMessageId';
import { getStore as getMailStore } from 'owa-mail-store/lib/store/Store';
import { getQueryStringParameter, hasQueryStringParameter } from 'owa-querystring';
import { useComputed } from 'owa-react-hooks/lib/useComputed';
import * as React from 'react';
import type ClientItem from 'owa-mail-store/lib/store/schema/ClientItem';
import {
    getStore as getPopoutChildStore,
    PopoutLoadingView,
    PopoutChildState,
} from 'owa-popout-v2';

import styles from 'owa-mail-module-view/lib/components/MailModule.scss';

export default observer(function DeepLinkMailView(props: { isItemAttachment?: boolean }) {
    const itemReadingPaneViewState = useComputed(
        (): ItemReadingPaneViewState => {
            return getItemReadingPaneViewState();
        }
    );
    const activeFullCompose =
        composeStore.primaryComposeId && composeStore.viewStates.get(composeStore.primaryComposeId);

    const item = useComputed(
        (): ClientItem => {
            // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
            // -> Error TS2322 (41,13): Type 'ClientItem | undefined' is not assignable to type 'ClientItem'.
            // @ts-expect-error
            return getMailStore().items.get(itemReadingPaneViewState.get()?.itemId);
        }
    );

    const isReadonly = itemReadingPaneViewState.get()?.isReadonly;
    const { state } = getPopoutChildStore();

    React.useEffect(() => {
        // If the item doesn't exist check if there is a ItemID query param decode it and use it
        // If the URL is redirected due to a logOnIndex
        // The path may be url decoded and the item id in the route params may be incorrect
        // i.e. from mail/deeplink to mail/0/deeplink
        if (!item.get() && hasQueryStringParameter(ITEMID_QUERY_PARAM)) {
            const itemId = decodeURIComponent(getQueryStringParameter(ITEMID_QUERY_PARAM));
            loadItemReadingPaneForDeeplink(itemId);
        }

        if (!item.get() && hasQueryStringParameter(IMID_QUERY_PARAM)) {
            const imid = decodeURIComponent(getQueryStringParameter(IMID_QUERY_PARAM));
            getItemIdFromInternetMessageId(imid).then(itemId => {
                loadItemReadingPaneForDeeplink(itemId);
            });
        }
    }, []);

    return state != PopoutChildState.Ready ? (
        <PopoutLoadingView loadingString={loc(loading)} />
    ) : (
        <>
            {!isFeatureEnabled('rp-immersiveReaderv2') && <ImmersiveReaderContainer />}
            <div className={styles.rightPane}>
                {!isReadonly && (
                    <div className={styles.commandBar}>
                        {activeFullCompose ? (
                            <ComposeCommandingBar composeViewState={activeFullCompose} />
                        ) : item.get()?.NormalizedBody && !props.isItemAttachment ? (
                            <DeeplinkMailItemCommandingBar
                                // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
                                // -> Error TS2322 (81,33): Type '{ mailboxInfo: MailboxInfo; __type?: string | undefined; Id?: string | undefined; ChangeKey?: string | undefined; }' is not assignable to type 'ClientItemId'.
                                // @ts-expect-error
                                itemId={{
                                    ...item.get().ItemId,
                                    mailboxInfo: item.get().MailboxInfo,
                                }}
                            />
                        ) : null}
                    </div>
                )}
                <div className={styles.readingPane}>
                    <ReadingPaneContainer isItemAttachment={props.isItemAttachment} />
                </div>
            </div>
        </>
    );
});
